import styled, { keyframes, createGlobalStyle, css } from 'styled-components';

// Animações
export const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

export const slideIn = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const shine = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const pulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const glowParticle = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
`;

export const floatUpDown = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
`;

export const gridAnimation = keyframes`
  0% {
    background-position: 0 0;
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    background-position: 100% 100%;
    opacity: 0.3;
  }
`;

export const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

export const glow = keyframes`
  0%, 100% {
    box-shadow: 0 0 20px rgba(42, 244, 151, 0.3);
  }
  50% {
    box-shadow: 0 0 40px rgba(42, 244, 151, 0.6);
  }
`;

export const numberCountUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const shimmer = keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;

export const floatSlow = keyframes`
  0% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(15px, -15px) rotate(5deg); }
  100% { transform: translate(0, 0) rotate(0deg); }
`;

export const rotateGradient = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const buttonPulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 30px rgba(42, 244, 151, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 50px rgba(42, 244, 151, 0.7);
  }
`;

export const floatUpDownSlow = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
`;

export const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const sparkle = keyframes`
  0%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const glitch = keyframes`
  0% {
    text-shadow: 0.05em 0 0 rgba(255, 0, 0, 0.75),
                -0.05em -0.025em 0 rgba(0, 255, 0, 0.75),
                -0.025em 0.05em 0 rgba(0, 0, 255, 0.75);
  }
  14% {
    text-shadow: 0.05em 0 0 rgba(255, 0, 0, 0.75),
                -0.05em -0.025em 0 rgba(0, 255, 0, 0.75),
                -0.025em 0.05em 0 rgba(0, 0, 255, 0.75);
  }
  15% {
    text-shadow: -0.05em -0.025em 0 rgba(255, 0, 0, 0.75),
                0.025em 0.025em 0 rgba(0, 255, 0, 0.75),
                -0.05em -0.05em 0 rgba(0, 0, 255, 0.75);
  }
  49% {
    text-shadow: -0.05em -0.025em 0 rgba(255, 0, 0, 0.75),
                0.025em 0.025em 0 rgba(0, 255, 0, 0.75),
                -0.05em -0.05em 0 rgba(0, 0, 255, 0.75);
  }
  50% {
    text-shadow: 0.025em 0.05em 0 rgba(255, 0, 0, 0.75),
                0.05em 0 0 rgba(0, 255, 0, 0.75),
                0 -0.05em 0 rgba(0, 0, 255, 0.75);
  }
  99% {
    text-shadow: 0.025em 0.05em 0 rgba(255, 0, 0, 0.75),
                0.05em 0 0 rgba(0, 255, 0, 0.75),
                0 -0.05em 0 rgba(0, 0, 255, 0.75);
  }
  100% {
    text-shadow: -0.025em 0 0 rgba(255, 0, 0, 0.75),
                -0.025em -0.025em 0 rgba(0, 255, 0, 0.75),
                -0.025em -0.05em 0 rgba(0, 0, 255, 0.75);
  }
`;

export const dataScroll = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 100%;
  }
`;

export const levelUp = keyframes`
  0% {
    opacity: 0.3;
    transform: translate(-50%, -50%) scale(0.9);
  }
  50% {
    opacity: 0.7;
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    opacity: 0.3;
    transform: translate(-50%, -50%) scale(0.9);
  }
`;

export const scanEffect = keyframes`
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(100%);
  }
`;

export const bounce = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`;

/* Keyframes para a Timeline seção */
export const pulseTimeline = keyframes`
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
`;

export const floatTimeline = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

export const rotateGlow = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const fadeInOut = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
`;

export const progressBar = keyframes`
  0% { width: 0%; }
  100% { width: 100%; }
`;

export const glitchAnim = keyframes`
  0% {
    textShadow: 0.05em 0 0 rgba(42, 244, 151, 0.75),
      -0.05em -0.025em 0 rgba(42, 244, 151, 0.75),
      -0.025em 0.05em 0 rgba(42, 244, 151, 0.75);
  }
  14% {
    textShadow: 0.05em 0 0 rgba(42, 244, 151, 0.75),
      -0.05em -0.025em 0 rgba(42, 244, 151, 0.75),
      -0.025em 0.05em 0 rgba(42, 244, 151, 0.75);
  }
  15% {
    textShadow: -0.05em -0.025em 0 rgba(42, 244, 151, 0.75),
      0.025em 0.025em 0 rgba(42, 244, 151, 0.75),
      -0.05em -0.05em 0 rgba(42, 244, 151, 0.75);
  }
  49% {
    textShadow: -0.05em -0.025em 0 rgba(42, 244, 151, 0.75),
      0.025em 0.025em 0 rgba(42, 244, 151, 0.75),
      -0.05em -0.05em 0 rgba(42, 244, 151, 0.75);
  }
  50% {
    textShadow: 0.025em 0.05em 0 rgba(42, 244, 151, 0.75),
      0.05em 0 0 rgba(42, 244, 151, 0.75),
      0 -0.05em 0 rgba(42, 244, 151, 0.75);
  }
  99% {
    textShadow: 0.025em 0.05em 0 rgba(42, 244, 151, 0.75),
      0.05em 0 0 rgba(42, 244, 151, 0.75),
      0 -0.05em 0 rgba(42, 244, 151, 0.75);
  }
  100% {
    textShadow: -0.025em 0 0 rgba(42, 244, 151, 0.75),
      -0.025em -0.025em 0 rgba(42, 244, 151, 0.75),
      -0.025em -0.05em 0 rgba(42, 244, 151, 0.75);
  }
`;

export const radarScan = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const bounceIn = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const dash = keyframes`
  0% {
    strokeDashoffset: 1000;
  }
  100% {
    strokeDashoffset: 0;
  }
`;

export const levelProgress = keyframes`
  0% {
    width: 0%;
    boxShadow: 0 0 5px #2af497, 0 0 10px #2af497;
  }
  100% {
    width: 100%;
    boxShadow: 0 0 15px #2af497, 0 0 25px #2af497;
  }
`;

export const bgScroll = keyframes`
  0% {
    backgroundPosition: 0% 0%;
  }
  100% {
    backgroundPosition: 100% 100%;
  }
`;

export const ctaGlow = keyframes`
  0%, 100% {
    box-shadow: 0 0 15px rgba(42, 244, 151, 0.6), 0 0 30px rgba(42, 244, 151, 0.4), 0 0 45px rgba(42, 244, 151, 0.2);
  }
  50% {
    box-shadow: 0 0 20px rgba(42, 244, 151, 0.8), 0 0 40px rgba(42, 244, 151, 0.6), 0 0 60px rgba(42, 244, 151, 0.3);
  }
`;

export const ctaParticle = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
`;

export const ctaArrow = keyframes`
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
`;

export const particlesFloat = keyframes`
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-15px) rotate(5deg);
  }
  50% {
    transform: translateY(-5px) rotate(-5deg);
  }
  75% {
    transform: translateY(-10px) rotate(3deg);
  }
`;

export const pulseScale = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
`;

export const glowEffect = keyframes`
  0% {
    box-shadow: 0 0 20px rgba(42, 244, 151, 0.6), 0 0 40px rgba(42, 244, 151, 0.3);
    transform: translateY(0) scale(1);
  }
  50% {
    box-shadow: 0 0 30px rgba(42, 244, 151, 0.8), 0 0 60px rgba(42, 244, 151, 0.4);
    transform: translateY(-5px) scale(1.03);
  }
  100% {
    box-shadow: 0 0 20px rgba(42, 244, 151, 0.6), 0 0 40px rgba(42, 244, 151, 0.3);
    transform: translateY(0) scale(1);
  }
`;

export const slideInRight = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideOutLeft = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
`;

export const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(26, 30, 36, 0.8);
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #2af497, #1ce488);
    border-radius: 5px;
    border: 2px solid rgba(26, 30, 36, 0.8);
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(180deg, #1ce488, #2af497);
    }
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    overflow-y: overlay;
  }
`;

// Componentes de estilo
export const Container = styled.div`
  min-height: 100vh;
  background: #1a1e24;
  color: #ffffff;
  overflow-x: hidden;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(26, 30, 36, 0.8);
  backdrop-filter: blur(8px);

  img {
    height: 40px;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    img {
      height: 30px;
    }
  }
`;

export const LoginButton = styled.button`
  background: transparent;
  border: 1px solid #2af497;
  color: #2af497;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(42, 244, 151, 0.1),
      transparent
    );
    transform: rotate(45deg);
    z-index: -1;
    transition: all 0.6s ease;
  }

  &:hover {
    background: #2af497;
    color: #0a0c10;
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(42, 244, 151, 0.3);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const HeroSection = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 100vh;
    padding-top: 60px; // Altura do header
  }
`;

export const VideoBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgb(23 26 32 / 96%), rgb(36 44 53 / 91%));
    z-index: 1;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: saturate(1.2) contrast(1.1);
  }
`;

export const HeroContent = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 60px); // Altura total menos o header
  padding: 1rem;

  .content-wrapper {
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 5;
    padding: 1rem;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
  }

  h1 {
    font-size: clamp(1.8rem, 5vw, 3.5rem);
    margin-bottom: 1rem;
    color: #ffffff;
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
    max-width: 900px;
    z-index: 5;
    position: relative;
  }

  p {
    font-size: clamp(0.9rem, 2vw, 1.2rem);
    margin-bottom: 1.5rem;
    color: #ffffff;
    opacity: 0.9;
    line-height: 1.6;
    text-align: center;
    max-width: 800px;
    z-index: 5;
    position: relative;
  }

  .floating-cards-container {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin: 2rem auto;
    padding: 0;
    z-index: 5;

    @media (min-width: 769px) {
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      padding: 0 120px;
    }
  }

  .cta-buttons {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    width: 100%;
    max-width: 500px;
    z-index: 5;
    position: relative;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;
      padding: 0 1rem;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    padding: 2rem 1rem;
  }
`;

export const FloatingCard = styled.div<{ delay: string }>`
  padding: 1.25rem;
  background: rgba(42, 244, 151, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(42, 244, 151, 0.2);
  border-radius: 12px;
  color: white;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 8px 32px rgba(42, 244, 151, 0.1);
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
  margin: 0.5rem auto;

  @media (min-width: 769px) {
    position: absolute;
    width: 250px;
    animation: ${css`${float}`} 6s ease-in-out infinite;
    animation-delay: ${props => props.delay};
  }

  @media (max-width: 768px) {
    animation: ${css`${slideIn}`} 0.6s ease-out forwards;
  }

  &:hover {
    transform: scale(1.02);
    background: rgba(42, 244, 151, 0.15);
  }

  svg {
    font-size: 1.75rem;
    color: #2af497;
    animation: ${css`${pulse}`} 3s ease-in-out infinite;
  }

  h4 {
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }

  p {
    font-size: 0.85rem;
    margin: 0;
  }
`;

export const StatsRing = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  border: 2px dashed rgba(42, 244, 151, 0.3);
  border-radius: 50%;
  animation: ${rotate} 30s linear infinite;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background: #2af497;
    border-radius: 50%;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
    opacity: 0.5;
  }

  @media (max-width: 480px) {
    width: 150px;
    height: 150px;
  }
`;

export const CTAButton = styled.button`
  background: linear-gradient(90deg, #2af497, #1ce488);
  color: #0a0c10;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  z-index: 3;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(42, 244, 151, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transform: rotate(45deg);
    z-index: -1;
    transition: all 0.6s ease;
    animation: ${shimmer} 3s linear infinite;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(42, 244, 151, 0.6);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: #ffffff;
  border: 1px solid #2af497;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  position: relative;
  z-index: 3;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(42, 244, 151, 0.1),
      transparent
    );
    transform: rotate(45deg);
    z-index: -1;
    transition: all 0.6s ease;
  }

  &:hover {
    background: rgba(42, 244, 151, 0.1);
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(42, 244, 151, 0.2);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FeaturesSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #0a1520 0%, #142234 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(42, 244, 151, 0.08) 0%, transparent 40%),
      radial-gradient(circle at 80% 70%, rgba(42, 167, 255, 0.08) 0%, transparent 40%);
    z-index: 0;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const FeatureCard = styled.div`
  background: rgba(42, 244, 151, 0.05);
  border: 1px solid rgba(42, 244, 151, 0.1);
  padding: 2rem;
  border-radius: 8px;
  transition: transform 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    background: #2af497;
    opacity: 0.1;
    border-radius: 0 0 0 30px;
  }

  svg {
    color: #2af497;
  }

  &:hover {
    transform: translateY(-5px);
  }

  h3 {
    color: #2af497;
    margin: 1rem 0;
    font-size: 1.5rem;
    font-weight: 500;
  }

  p {
    color: #ffffff;
    opacity: 0.9;
    line-height: 1.6;
  }
`;

export const AIStatsSection = styled.section`
  position: relative;
  min-height: 100vh;
  background: #0a0c10;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 0;

  .decorative-ring {
    position: absolute;
    border: 2px dashed rgba(42, 244, 151, 0.15);
    border-radius: 50%;
    animation: ${rotate} 20s linear infinite;

    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      background: #2af497;
      border-radius: 50%;
      box-shadow: 0 0 20px rgba(42, 244, 151, 0.5);
    }

    &.ring-1 {
      width: 300px;
      height: 300px;
      top: 20%;
      left: 10%;
      &::before {
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      @media (max-width: 768px) {
        width: 200px;
        height: 200px;
        top: 15%;
        left: 5%;
      }

      @media (max-width: 480px) {
        width: 150px;
        height: 150px;
        top: 10%;
        left: 0;
      }
    }

    &.ring-2 {
      width: 200px;
      height: 200px;
      bottom: 20%;
      right: 10%;
      animation-direction: reverse;
      &::before {
        bottom: 0;
        right: 50%;
        transform: translate(50%, 50%);
      }

      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
        bottom: 15%;
        right: 5%;
      }

      @media (max-width: 480px) {
        width: 100px;
        height: 100px;
        bottom: 10%;
        right: 0;
      }
    }
  }

  .floating-orb {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(circle at center, rgba(42, 244, 151, 0.2), transparent);
    animation: ${float} 6s ease-in-out infinite;

    &.orb-1 {
      width: 200px;
      height: 200px;
      top: 15%;
      left: 15%;
      animation-delay: 0s;

      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
        top: 12%;
        left: 10%;
      }

      @media (max-width: 480px) {
        width: 100px;
        height: 100px;
        top: 8%;
        left: 5%;
      }
    }

    &.orb-2 {
      width: 150px;
      height: 150px;
      top: 60%;
      right: 15%;
      animation-delay: 2s;

      @media (max-width: 768px) {
        width: 120px;
        height: 120px;
        top: 50%;
        right: 10%;
      }

      @media (max-width: 480px) {
        width: 80px;
        height: 80px;
        top: 40%;
        right: 5%;
      }
    }

    &.orb-3 {
      width: 100px;
      height: 100px;
      top: 40%;
      left: 50%;
      animation-delay: 4s;

      @media (max-width: 768px) {
        width: 80px;
        height: 80px;
        top: 35%;
        left: 45%;
      }

      @media (max-width: 480px) {
        width: 60px;
        height: 60px;
        top: 30%;
        left: 40%;
      }
    }
  }
`;

export const StatsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  position: relative;
  z-index: 2;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  background: rgba(18, 21, 24, 0.95);
  border: 1px solid rgba(42, 244, 151, 0.1);
  border-radius: 20px;
  padding: 2rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  animation: ${fadeIn} 0.6s ease-out forwards;
  backdrop-filter: blur(10px);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 200%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(42, 244, 151, 0.1),
      transparent
    );
    animation: ${shimmer} 3s infinite;
  }

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(42, 244, 151, 0.3);
    animation: ${glow} 2s infinite;
  }

  .number {
    font-size: 4.5rem;
    font-weight: bold;
    background: linear-gradient(90deg, #2af497, #1ce488);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: 'Agency FB', sans-serif;
    margin-bottom: 1rem;
    line-height: 1;
    animation: ${numberCountUp} 1s ease-out forwards;
    opacity: 0;
    transform: translateY(20px);
  }

  .label {
    font-size: 1.2rem;
    color: #fff;
    margin-bottom: 2rem;
    opacity: 0;
    animation: ${fadeIn} 0.6s ease-out forwards;
    animation-delay: 0.3s;
  }

  .features {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Feature = styled.div`
  background: rgba(42, 244, 151, 0.05);
  border: 1px solid rgba(42, 244, 151, 0.1);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
  opacity: 0;
  animation: ${fadeIn} 0.6s ease-out forwards;
  animation-delay: 0.6s;

  &:hover {
    transform: translateY(-2px) scale(1.02);
    background: rgba(42, 244, 151, 0.1);
    box-shadow: 0 10px 20px rgba(42, 244, 151, 0.1);
  }

  .icon {
    color: #2af497;
    font-size: 1.5rem;
    min-width: 24px;
    animation: ${pulse} 2s infinite;
  }

  .content {
    text-align: left;

    h4 {
      color: #2af497;
      font-size: 1rem;
      margin-bottom: 0.25rem;
      transition: all 0.3s ease;
    }

    p {
      color: #fff;
      font-size: 0.9rem;
      opacity: 0.8;
      margin: 0;
      transition: all 0.3s ease;
    }
  }

  &:hover .content {
    h4 {
      transform: translateX(5px);
    }
    p {
      opacity: 1;
    }
  }
`;

export const StatsMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(42, 244, 151, 0.1);
  opacity: 0;
  animation: ${fadeIn} 0.6s ease-out forwards;
  animation-delay: 0.9s;

  .metric {
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    .value {
      color: #2af497;
      font-size: 1.5rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
      background: linear-gradient(90deg, #2af497, #1ce488);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .label {
      color: #fff;
      font-size: 0.9rem;
      opacity: 0.8;
      transition: all 0.3s ease;
    }

    &:hover .label {
      opacity: 1;
      transform: translateY(-2px);
    }
  }
`;

export const TestimonialSlider = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 300px;
  perspective: 1000px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    min-height: 400px;
    padding: 1rem;
  }
`;

export const TestimonialCard = styled.div<{ isActive: boolean; isNext: boolean }>`
  background: rgba(36, 44, 53, 0.8);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid rgba(42, 244, 151, 0.1);
  margin: 0 1rem;
  position: absolute;
  width: calc(100% - 2rem);
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${props => props.isNext ? 'translateX(100%)' : 'translateX(-100%)'};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: ${props => props.isActive ? 'block' : 'none'};

  ${props => props.isActive && css`
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  `}

  .testimonial-header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 1.5rem;

    .avatar-container {
      position: relative;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid rgba(42, 244, 151, 0.3);
      box-shadow: 0 0 20px rgba(42, 244, 151, 0.2);
    }

    .user-info {
      flex: 1;

      h4 {
        font-size: 1.3rem;
        margin-bottom: 0.5rem;
        color: #fff;
        font-weight: 600;
      }

      .rating {
        color: #2af497;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }
  }

  p {
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.8;
    font-size: 1.1rem;
    margin: 0;
    position: relative;

    &::before {
      content: '"';
      font-size: 4rem;
      position: absolute;
      top: -1rem;
      left: -1rem;
      color: rgba(42, 244, 151, 0.2);
      font-family: serif;
    }
  }

  &:hover {
    transform: ${props => props.isActive ? 'scale(1.02)' : 'none'};
    border-color: rgba(42, 244, 151, 0.3);
  }
`;

export const TestimonialDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 2rem;
  position: relative;
  z-index: 2;
  width: 100%;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: ${props => props.active ? '#2af497' : 'rgba(42, 244, 151, 0.2)'};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: #2af497;
    transform: scale(0);
    transition: transform 0.3s ease;
    border-radius: 50%;
  }

  &:hover {
    transform: scale(1.2);
    background: ${props => props.active ? '#2af497' : 'rgba(42, 244, 151, 0.4)'};
  }

  ${props => props.active && css`
    &::before {
      transform: scale(1);
      animation: ${css`${pulse}`} 2s infinite;
    }
  `}
`;

export const CEOSection = styled.section`
  position: relative;
  padding: 6rem 2rem;
  background-color: #0a0c10;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "title title"
    "content image";
  gap: 3rem;
  overflow: hidden;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
    grid-template-areas:
      "title"
      "image"
      "content";
    padding: 4rem 1.5rem;
    gap: 2rem;
  }
`;

export const CEOContent = styled.div`
  grid-area: content;
  position: relative;
  z-index: 2;

  h2 {
    font-size: 3rem;
    margin-bottom: 1.5rem;
    color: #2af497;
    line-height: 1.2;
    position: relative;
    text-shadow: 0 0 20px rgba(42, 244, 151, 0.5);
    animation: ${glitch} 5s infinite;

    &::before {
      content: "TRADING MASTER";
      position: absolute;
      top: -25px;
      left: 0;
      font-size: 1rem;
      letter-spacing: 4px;
      background: linear-gradient(90deg, #2af497, #1ce488);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      opacity: 0.8;
    }
  }

  p {
    color: #ffffff;
    opacity: 0.9;
    line-height: 1.6;
    margin-bottom: 2rem;
    font-size: 1.1rem;
    position: relative;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.2);

    &::first-letter {
      font-size: 1.5em;
      color: #2af497;
    }
  }

  .stats-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    margin: 2rem 0;
  }

  .stat-item {
    background: rgba(26, 30, 36, 0.6);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(42, 244, 151, 0.2);
    border-radius: 8px;
    padding: 1rem;
    position: relative;
    overflow: hidden;

    .stat-title {
      font-size: 0.9rem;
      color: #ffffff;
      opacity: 0.8;
      margin-bottom: 0.5rem;
    }

    .stat-value {
      font-size: 1.8rem;
      font-weight: bold;
      color: #2af497;
      margin-bottom: 0.5rem;
    }

    .stat-bar {
      height: 6px;
      background: rgba(42, 244, 151, 0.2);
      border-radius: 3px;
      overflow: hidden;

      &::before {
        content: "";
        display: block;
        height: 100%;
        width: var(--progress, 90%);
        background: linear-gradient(90deg, #2af497, #1ce488);
        border-radius: 3px;
        animation: ${pulse} 3s ease-in-out infinite;
      }
    }
  }
`;

export const CEOImageWrapper = styled.div`
  grid-area: image;
  position: relative;
  z-index: 2;
`;

// Criando uma animação de brilho para a borda lendária
const legendaryGlow = keyframes`
  0% {
    box-shadow: 0 0 15px #2af497, 0 0 25px rgba(125, 0, 255, 0.3);
    border-color: #2af497;
  }
  50% {
    box-shadow: 0 0 20px #2af497, 0 0 30px rgba(125, 0, 255, 0.3);
    border-color: #1ce488;
  }
  100% {
    box-shadow: 0 0 15px #2af497, 0 0 25px rgba(125, 0, 255, 0.3);
    border-color: #2af497;
  }
`;

const breatheAnimation = keyframes`
  0% {
    transform: scale(1) translateZ(0);
  }
  50% {
    transform: scale(1.02) translateZ(10px);
  }
  100% {
    transform: scale(1) translateZ(0);
  }
`;

const rotateCard = keyframes`
  0% {
    transform: perspective(1000px) rotateY(0deg) rotateX(0deg);
  }
  25% {
    transform: perspective(1000px) rotateY(2deg) rotateX(-1deg);
  }
  75% {
    transform: perspective(1000px) rotateY(-2deg) rotateX(1deg);
  }
  100% {
    transform: perspective(1000px) rotateY(0deg) rotateX(0deg);
  }
`;

const floatAnimation = keyframes`
  0% {
    transform: translateY(0) translateZ(20px) rotateX(0) rotateY(0);
  }
  25% {
    transform: translateY(-15px) translateZ(40px) rotateX(5deg) rotateY(2deg);
  }
  75% {
    transform: translateY(5px) translateZ(30px) rotateX(-3deg) rotateY(-2deg);
  }
  100% {
    transform: translateY(0) translateZ(20px) rotateX(0) rotateY(0);
  }
`;

const cardMotion = keyframes`
  0% {
    transform: perspective(2000px) rotateY(0deg) translateZ(0) translateX(0);
  }
  25% {
    transform: perspective(2000px) rotateY(15deg) translateZ(50px) translateX(20px);
  }
  75% {
    transform: perspective(2000px) rotateY(-15deg) translateZ(100px) translateX(-20px);
  }
  100% {
    transform: perspective(2000px) rotateY(0deg) translateZ(0) translateX(0);
  }
`;

const infiniteDepth = keyframes`
  0% {
    transform: translateZ(50px) scale(1);
    filter: brightness(1) contrast(1.1);
  }
  50% {
    transform: translateZ(150px) scale(1.05);
    filter: brightness(1.2) contrast(1.2);
  }
  100% {
    transform: translateZ(50px) scale(1);
    filter: brightness(1) contrast(1.1);
  }
`;

const badgeFloat = keyframes`
  0% {
    transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(20px);
  }
  25% {
    transform: perspective(1000px) rotateX(10deg) rotateY(5deg) translateZ(40px);
  }
  75% {
    transform: perspective(1000px) rotateX(-5deg) rotateY(-10deg) translateZ(60px);
  }
  100% {
    transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(20px);
  }
`;

export const CEOImageContainer = styled.div`
  position: relative;
  width: 300px;
  height: 450px;
  margin: 0 auto;
  margin-bottom: 20px;
  border-radius: 12px;
  perspective: 2000px;
  transform-style: preserve-3d;
  animation: ${cardMotion} 8s infinite ease-in-out;
  background: linear-gradient(
    135deg,
    rgba(13, 26, 38, 0.95),
    rgba(21, 42, 36, 0.95)
  );
  border: 2px solid rgba(42, 244, 151, 0.6);
  box-shadow:
    0 0 30px rgba(42, 244, 151, 0.3),
    0 0 60px rgba(42, 244, 151, 0.2),
    0 0 90px rgba(42, 244, 151, 0.1);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: -2px;
    background: linear-gradient(
      135deg,
      rgba(42, 244, 151, 0.5),
      rgba(125, 0, 255, 0.3),
      rgba(42, 244, 151, 0.5)
    );
    z-index: -1;
    animation: ${rotateGradient} 3s linear infinite;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    transform-style: preserve-3d;
    animation: ${infiniteDepth} 6s infinite ease-in-out;
    filter: contrast(1.1) saturate(1.2);
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  .legendary-aura {
    position: absolute;
    inset: -20px;
    background: radial-gradient(
      circle at center,
      rgba(42, 244, 151, 0.3) 0%,
      rgba(125, 0, 255, 0.2) 50%,
      transparent 70%
    );
    border-radius: 20px;
    z-index: -2;
    animation: ${pulse} 4s infinite ease-in-out;
    filter: blur(10px);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      transparent,
      rgba(42, 244, 151, 0.1),
      transparent
    );
    border-radius: 12px;
    z-index: 1;
    pointer-events: none;
    animation: ${shine} 3s infinite linear;
  }
`;

export const PlayerAttribute = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(10, 15, 20, 0.7);
  border: 1px solid rgba(42, 244, 151, 0.4);
  padding: 5px 10px;
  border-radius: 5px;
  color: white;

  .attribute-icon {
    color: #2af497;
    font-size: 1.1rem;
  }

  .attribute-text {
    font-size: 0.9rem;
    font-weight: 600;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
`;

export const BadgesRow = styled.div`
  grid-area: badges;
  display: none; /* Escondendo a fileira de badges antiga */
`;

export const GameBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.75rem 1.5rem;
  background: rgba(10, 15, 20, 0.7);
  border: 1px solid rgba(42, 244, 151, 0.8);
  width: 100%;
  border-radius: 6px;
  color: white;
  box-shadow: 0 0 15px rgba(42, 244, 151, 0.3), inset 0 0 10px rgba(42, 244, 151, 0.1);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
  text-shadow: 0 0 10px rgba(42, 244, 151, 0.5);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(42, 244, 151, 0.05) 50%,
      transparent 100%
    );
    opacity: 1;
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    height: 100%;
    width: 20px;
    background: linear-gradient(to right,
      rgba(42, 244, 151, 0.1),
      rgba(42, 244, 151, 0.3),
      rgba(42, 244, 151, 0.1)
    );
    left: -20px;
    top: 0;
    filter: blur(1px);
    animation: scanRight 3s ease-in-out infinite;
  }

  @keyframes scanRight {
    0% { left: -20px; opacity: 0; }
    10% { opacity: 1; }
    100% { left: 100%; opacity: 0; }
  }

  &:hover {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 0 20px rgba(42, 244, 151, 0.5), inset 0 0 15px rgba(42, 244, 151, 0.2);
    border-color: rgba(42, 244, 151, 1);
  }

  .badge-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2af497;
    font-size: 1.5rem;
    min-width: 40px;
    min-height: 40px;
    background: rgba(10, 15, 20, 0.7);
    border-radius: 50%;
    padding: 8px;
    border: 1px solid rgba(42, 244, 151, 0.5);
    box-shadow: 0 0 10px rgba(42, 244, 151, 0.3);
    filter: drop-shadow(0 0 5px rgba(42, 244, 151, 0.7));
  }

  .badge-text {
    font-size: 1rem;
    font-weight: 600;
    color: white;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.power-level {
    background: linear-gradient(90deg, rgba(10, 15, 20, 0.9), rgba(42, 244, 151, 0.1));
    animation: ${pulse} 2s infinite;
    border-color: rgba(42, 244, 151, 1);
    box-shadow: 0 0 25px rgba(42, 244, 151, 0.5), inset 0 0 15px rgba(42, 244, 151, 0.2);

    .badge-icon {
      background: rgba(42, 244, 151, 0.2);
      animation: ${pulse} 2.5s infinite;
    }

    .badge-text {
      font-size: 1.2rem;
      font-weight: 700;
      color: #2af497;
    }
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1rem;

    .badge-icon {
      font-size: 1.3rem;
      min-width: 35px;
      min-height: 35px;
    }

    .badge-text {
      font-size: 0.9rem;
    }
  }
`;

export const LevelUpEffect = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(42, 244, 151, 0.4) 0%, transparent 70%);
  z-index: 3;
  pointer-events: none;
  animation: ${levelUp} 4s ease-in-out infinite;
`;

export const MiyagiButton = styled.button`
  background: linear-gradient(90deg, #2af497, #1ce488);
  color: #0a0c10;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  z-index: 3;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(42, 244, 151, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transform: rotate(45deg);
    z-index: -1;
    transition: all 0.6s ease;
    animation: ${shimmer} 3s linear infinite;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(42, 244, 151, 0.6);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const PricingSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(
    135deg,
    rgba(10, 12, 16, 0.95),
    rgba(26, 30, 36, 0.95),
    rgba(20, 24, 28, 0.95)
  );
  background-size: 400% 400%;
  animation: ${gradientShift} 15s ease infinite;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: radial-gradient(circle at center, rgba(42, 244, 151, 0.1) 0%, transparent 70%);
    z-index: 1;
  }

  .sparkles {
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: rgba(42, 244, 151, 0.8);
    border-radius: 50%;
    filter: blur(2px);
    animation: ${sparkle} 3s ease-in-out infinite;
    z-index: 1;
  }

  h2 {
    font-size: 3.2rem;
    margin-bottom: 1.5rem;
    color: #ffffff;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.2;
    position: relative;
    z-index: 2;
    animation: ${fadeIn} 0.8s ease-out forwards;
    text-shadow: 0 0 20px rgba(42, 244, 151, 0.3);
  }

  p {
    color: #ffffff;
    opacity: 0.9;
    margin-bottom: 3rem;
    font-size: 1.3rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 2;
    animation: ${fadeIn} 0.8s ease-out forwards;
    animation-delay: 0.2s;
  }

  .register-benefits {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 2rem auto 3rem;
    max-width: 1000px;
    position: relative;
    z-index: 2;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 768px) {
    padding: 4rem 1rem;

    h2 {
      font-size: 2.5rem;
    }

    p {
      font-size: 1.1rem;
    }
  }
`;

export const Benefit = styled.div`
  display: flex;
  align-items: center;
  background: rgba(26, 30, 36, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(42, 244, 151, 0.2);
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin: 0.75rem;
  width: calc(33% - 1.5rem);
  min-width: 250px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  animation: ${fadeIn} 0.5s ease-out forwards;
  opacity: 0;

  &:nth-child(1) { animation-delay: 0.3s; }
  &:nth-child(2) { animation-delay: 0.5s; }
  &:nth-child(3) { animation-delay: 0.7s; }
  &:nth-child(4) { animation-delay: 0.9s; }
  &:nth-child(5) { animation-delay: 1.1s; }
  &:nth-child(6) { animation-delay: 1.3s; }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(42, 244, 151, 0.15);
    border-color: rgba(42, 244, 151, 0.4);
  }

  .icon {
    font-size: 2rem;
    color: #2af497;
    margin-right: 1.25rem;
    min-width: 2rem;
  }

  .content {
    flex: 1;
    text-align: left;

    h4 {
      font-size: 1.1rem;
      color: #2af497;
      margin-bottom: 0.25rem;
    }

    p {
      font-size: 0.9rem;
      color: white;
      opacity: 0.8;
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 0.5rem 0;
  }
`;

export const RegisterButton = styled.button`
  background: linear-gradient(90deg, #2af497, #1ce488);
  color: #0a0c10;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  z-index: 3;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(42, 244, 151, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  overflow: hidden;
  margin-top: 1rem;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transform: rotate(45deg);
    z-index: -1;
    transition: all 0.6s ease;
    animation: ${shimmer} 3s linear infinite;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(42, 244, 151, 0.6);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 1rem 1.5rem;
  }
`;

export const GlowingOrb = styled.div<{ size: string; top: string; left: string; delay: string }>`
  position: absolute;
  width: ${props => props.size};
  height: ${props => props.size};
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(42, 244, 151, 0.3) 0%, transparent 70%);
  top: ${props => props.top};
  left: ${props => props.left};
  filter: blur(20px);
  animation: ${floatUpDownSlow} 8s ease-in-out infinite;
  animation-delay: ${props => props.delay};
  z-index: 1;
`;

export const PricingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const PricingCard = styled.div`
  background: #1a1e24;
  padding: 2rem;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(42, 244, 151, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  h3 {
    color: #2af497;
    font-size: 1.8rem;
    margin-bottom: 1rem;
    font-weight: 500;
  }

  .price {
    font-size: 2.5rem;
    color: #ffffff;
    margin-bottom: 2rem;
    font-weight: 600;
  }

  .discount {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: rgba(42, 244, 151, 0.1);
    color: #2af497;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 500;
  }
`;

export const Footer = styled.footer`
  background: #1a1e24;
  padding: 3rem 2rem;
  text-align: center;
  color: #ffffff;
  opacity: 0.9;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .company-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1.5rem;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);
  }

  .contact {
    color: #2af497;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      text-decoration: underline;
      color: #1ce488;
    }
  }
`;

export const DataTimelineSection = styled.section`
  position: relative;
  padding: 6rem 0;
  overflow: hidden;
  background: linear-gradient(135deg, #0a1520 0%, #142234 100%);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(42, 244, 151, 0.12) 0%, transparent 40%),
      radial-gradient(circle at 80% 70%, rgba(42, 167, 255, 0.12) 0%, transparent 40%);
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='rgba(255,255,255,0.05)' fill-rule='evenodd'/%3E%3C/svg%3E"),
      linear-gradient(to bottom, transparent, #0a0a14);
    background-size: 150px 150px, 100% 100%;
    opacity: 0.5;
    z-index: 0;
    pointer-events: none;
  }
`;

export const TimelineContainer = styled.div`
  position: relative;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 1.5rem;
  z-index: 1;
`;

export const TimelineHeading = styled.div`
  margin-bottom: 4rem;
  text-align: center;
  position: relative;

  h2 {
    margin: 0;
    font-size: 3rem;
    font-weight: 800;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 2px;
    animation: ${glitchAnim} 2s infinite;
  }

  p {
    font-size: 1.25rem;
    color: rgba(255, 255, 255, 0.7);
    max-width: 800px;
    margin: 1rem auto 0;
  }

  &::after {
    content: '';
    display: block;
    width: 100px;
    height: 4px;
    background: linear-gradient(90deg, #2af497, #1ce488);
    margin: 1.5rem auto 0;
    border-radius: 2px;
    animation: ${pulseTimeline} 2s infinite;
  }
`;

export const TimelineMap = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const TimelineNode = styled.div`
  position: relative;
  background: rgba(20, 34, 52, 0.6);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  padding: 2rem 1.5rem 1.5rem;
  transition: all 0.3s ease;
  border: 1px solid rgba(42, 244, 151, 0.2);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: visible;
  animation: ${css`${bounceIn}`} 0.5s ease-out both;
  animation-delay: calc(var(--index, 0) * 0.1s);
  transform-origin: center bottom;
  margin-top: 15px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(42, 244, 151, 0.8), transparent);
    animation: ${css`${progressBar}`} 3s ease-in-out infinite;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(135deg, rgba(42, 244, 151, 0.5), rgba(42, 167, 255, 0.5));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    opacity: 0.7;
  }

  .node-content {
    position: relative;
    z-index: 2;
  }

  .node-icon {
    font-size: 2.5rem;
    margin-bottom: 1.2rem;
    color: #2af497;
    animation: ${css`${floatTimeline}`} 3s ease-in-out infinite;
    display: inline-block;
    filter: drop-shadow(0 0 8px rgba(42, 244, 151, 0.6));
  }

  .node-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0 0 0.8rem;
    color: #fff;
    text-shadow: 0 0 10px rgba(42, 244, 151, 0.5);
  }

  .node-description {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  .glow-effect {
    position: absolute;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(42, 244, 151, 0.3) 0%, transparent 70%);
    top: -75px;
    right: -75px;
    animation: ${css`${rotateGlow}`} 10s linear infinite;
    pointer-events: none;
    opacity: 0.7;
  }

  .radar-scan {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: transparent;
    border: 2px solid rgba(42, 244, 151, 0.3);
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 50%;
      height: 2px;
      background: linear-gradient(90deg, rgba(42, 244, 151, 0.8), transparent);
      transform-origin: left center;
      animation: ${css`${radarScan}`} 3s linear infinite;
    }
  }

  .progress-bar {
    height: 6px;
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow: hidden;
    margin: 1rem 0;

    .progress {
      height: 100%;
      background: linear-gradient(90deg, #2af497, #1ce488);
      border-radius: 3px;
      animation: ${css`${levelProgress}`} 3s ease-out infinite;
      box-shadow: 0 0 10px rgba(42, 244, 151, 0.5);
    }
  }

  .badge {
    position: absolute;
    top: -15px;
    left: -15px;
    background: linear-gradient(45deg, #2af497, #1ce488);
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.4rem 0.7rem;
    border-radius: 20px;
    box-shadow: 0 5px 15px rgba(42, 244, 151, 0.3);
    z-index: 3;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    animation: ${css`${pulse}`} 2s infinite;
  }

  .stat-item {
    text-align: center;
    flex: 1;

    .stat-value {
      font-size: 1.3rem;
      font-weight: 700;
      color: #2af497;
      text-shadow: 0 0 10px rgba(42, 244, 151, 0.7);
    }

    .stat-label {
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 0.2rem;
    }
  }

  .node-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .stat-item {
    text-align: center;
    flex: 1;

    .stat-value {
      font-size: 1.3rem;
      font-weight: 700;
      color: #2af497;
      text-shadow: 0 0 10px rgba(42, 244, 151, 0.7);
    }

    .stat-label {
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 0.2rem;
    }
  }

  .progress-bar {
    height: 6px;
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow: hidden;
    margin: 1rem 0;

    .progress {
      height: 100%;
      background: linear-gradient(90deg, #2af497, #1ce488);
      border-radius: 3px;
      animation: ${css`${levelProgress}`} 3s ease-out infinite;
      box-shadow: 0 0 10px rgba(42, 244, 151, 0.5);
    }
  }

  .badge {
    position: absolute;
    top: -15px;
    left: -15px;
    background: linear-gradient(45deg, #2af497, #1ce488);
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.4rem 0.7rem;
    border-radius: 20px;
    box-shadow: 0 5px 15px rgba(42, 244, 151, 0.3);
    z-index: 3;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    animation: ${css`${pulse}`} 2s infinite;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);

    &::after {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    .node-icon {
      font-size: 2rem;
    }

    .node-title {
      font-size: 1.3rem;
    }
  }
`;

export const TimelineConnection = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2af497, #1ce488);
  transform: translateY(-50%);
  z-index: 0;
  opacity: 0.7;

  &::before, &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #2af497;
    transform: translateY(-50%);
    animation: ${css`${pulseTimeline}`} 2s infinite alternate;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }

  @media (max-width: 992px) {
    display: none;
  }
`;

export const DataVisualization = styled.div`
  margin-top: 4rem;
  background: rgba(30, 30, 50, 0.4);
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid rgba(42, 244, 151, 0.15);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(42, 244, 151, 0.05) 100%);
    z-index: 0;
    pointer-events: none;
  }

  .data-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    z-index: 1;
    position: relative;
  }

  .data-card {
    background: rgba(20, 20, 40, 0.7);
    border-radius: 10px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: all 0.3s ease;
    border: 1px solid rgba(42, 244, 151, 0.1);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    }

    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;

      .card-icon {
        font-size: 1.8rem;
        margin-right: 1rem;
        color: #2af497;
      }

      .card-title {
        font-size: 1.2rem;
        font-weight: 600;
        color: #fff;
        margin: 0;
      }
    }

    .card-content {
      flex: 1;

      .data-value {
        font-size: 2rem;
        font-weight: 700;
        color: #2af497;
        margin: 0.5rem 0;
        text-shadow: 0 0 10px rgba(42, 244, 151, 0.5);
      }

      .data-description {
        font-size: 0.9rem;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.5;
      }
    }
  }
`;

export const CTAOutro = styled.div`
  margin-top: 4rem;
  text-align: center;

  .cta-title {
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1rem;
    text-shadow: 0 0 15px rgba(42, 244, 151, 0.7);
  }

  .cta-description {
    font-size: 1.1rem;
    color: rgba(255, 255, 255, 0.8);
    max-width: 800px;
    margin: 0 auto 2rem;
  }

  .cta-button {
    background: linear-gradient(90deg, #2af497, #1ce488);
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 1rem 2.5rem;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 10px 20px rgba(42, 244, 151, 0.3);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
      transform: rotate(45deg);
      animation: ${bgScroll} 1.5s linear infinite;
      z-index: 1;
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 25px rgba(42, 244, 151, 0.4);
    }
  }
`;

export const LightRays = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  background: rgba(42, 244, 151, 0.1);
  box-shadow: 0 0 50px 30px rgba(42, 244, 151, 0.05);
  transform: translateX(-50%);
  z-index: 0;
  pointer-events: none;

  &::before, &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 1px;
    height: 100%;
    background: rgba(42, 244, 151, 0.1);
    box-shadow: 0 0 50px 30px rgba(42, 244, 151, 0.05);
  }

  &::before {
    left: -300px;
  }

  &::after {
    right: -300px;
  }
`;

export const PowerButton = styled.button`
  position: relative;
  background: linear-gradient(90deg, #2af497, #1ce488);
  color: #121920;
  border: none;
  padding: 1.5rem 3rem;
  font-size: 1.3rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px;
  border-radius: 50px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  box-shadow: 0 10px 25px rgba(42, 244, 151, 0.5);
  animation: ${css`${ctaGlow}`} 3s infinite alternate;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transform: translateX(-100%);
    transition: transform 0.6s ease;
    z-index: -1;
  }

  .particles-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }

  .button-text {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button-icon {
    margin-left: 10px;
    transform: translateX(0);
    transition: transform 0.3s ease;
  }

  .pulse-circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(42, 244, 151, 0.8);
    transform: translate(-50%, -50%) scale(0);
    animation: ${css`${ctaParticle}`} 1.5s infinite;
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-7px) scale(1.05);
    box-shadow: 0 20px 40px rgba(42, 244, 151, 0.6);
    animation: ${css`${glowEffect}`} 2s infinite;

    &::before {
      transform: translateX(100%);
    }

    .button-icon {
      transform: translateX(5px);
    }
  }

  &:active {
    transform: translateY(2px) scale(0.98);
    box-shadow: 0 5px 15px rgba(42, 244, 151, 0.4);
  }
`;

export const TestimonialsSection = styled.section`
  padding: 6rem 2rem;
  background: #1a1e24;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(42, 244, 151, 0.05) 0%, transparent 70%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 4rem 1rem;
  }
`;

export const CardHeader = styled.div`
  position: absolute;
  top: 10px;
  left: 0;
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 3;
  transform-style: preserve-3d;
  transform: translateZ(5px);
`;

export const CardRating = styled.div`
  background: linear-gradient(135deg, #ffb700, #ff7800);
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 16px;
  box-shadow: 0 0 10px rgba(255, 183, 0, 0.7), 0 0 20px rgba(255, 120, 0, 0.4);
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  animation: ${pulse} 2s infinite ease-in-out;
  border: 1px solid rgba(255, 255, 255, 0.3);
  transform-style: preserve-3d;
  transform: translateZ(10px);

  &::before {
    content: 'LVL ';
    margin-right: 2px;
    font-size: 14px;
  }
`;

export const CardPosition = styled.div`
  background: rgba(13, 26, 38, 0.8);
  color: #2af497;
  font-weight: bold;
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 16px;
  box-shadow: 0 0 10px rgba(42, 244, 151, 0.5);
  border: 1px solid rgba(42, 244, 151, 0.4);
  text-shadow: 0 0 5px rgba(42, 244, 151, 0.5);
  transform-style: preserve-3d;
  transform: translateZ(10px);
`;

export const CardBadges = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: linear-gradient(
    0deg,
    rgba(13, 26, 38, 0.98) 0%,
    rgba(21, 42, 36, 0.95) 100%
  );
  z-index: 3;
  height: 100px;
  border-top: 2px solid rgba(42, 244, 151, 0.6);
  transform-style: preserve-3d;
  transform: translateZ(30px);
  box-shadow:
    0 -8px 20px rgba(0, 0, 0, 0.5),
    0 -4px 10px rgba(42, 244, 151, 0.2);

  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(
      90deg,
      rgba(42, 244, 151, 0.4),
      rgba(125, 0, 255, 0.6),
      rgba(42, 244, 151, 0.4)
    );
    background-size: 200% 100%;
    animation: ${shine} 3s infinite linear;
  }
`;

const floatBadge = keyframes`
  0% {
    transform: translateY(0) translateZ(0) rotateX(0);
  }
  50% {
    transform: translateY(-5px) translateZ(20px) rotateX(10deg);
  }
  100% {
    transform: translateY(0) translateZ(0) rotateX(0);
  }
`;

const glowIcon = keyframes`
  0% {
    filter: drop-shadow(0 0 8px rgba(42, 244, 151, 0.6));
    border-color: rgba(42, 244, 151, 0.4);
  }
  50% {
    filter: drop-shadow(0 0 15px rgba(42, 244, 151, 0.8));
    border-color: rgba(42, 244, 151, 0.8);
  }
  100% {
    filter: drop-shadow(0 0 8px rgba(42, 244, 151, 0.6));
    border-color: rgba(42, 244, 151, 0.4);
  }
`;

export const CardBadgeItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  transform-style: preserve-3d;
  animation: ${badgeFloat} 6s infinite ease-in-out;
  perspective: 1000px;

  &:nth-child(1) { animation-delay: 0s; }
  &:nth-child(2) { animation-delay: -1.5s; }
  &:nth-child(3) { animation-delay: -3s; }
  &:nth-child(4) { animation-delay: -4.5s; }

  .badge-icon {
    width: 45px;
    height: 45px;
    margin-bottom: 6px;
    font-size: 24px;
    color: #2af497;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      135deg,
      rgba(42, 244, 151, 0.3),
      rgba(125, 0, 255, 0.2)
    );
    border-radius: 50%;
    padding: 10px;
    border: 2px solid rgba(42, 244, 151, 0.6);
    box-shadow:
      0 4px 12px rgba(0, 0, 0, 0.4),
      0 0 20px rgba(42, 244, 151, 0.5),
      0 0 40px rgba(42, 244, 151, 0.3);
    transform-style: preserve-3d;
    transform: translateZ(30px);
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    animation: ${glowIcon} 3s infinite ease-in-out;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: radial-gradient(
        circle at center,
        rgba(42, 244, 151, 0.4) 0%,
        rgba(125, 0, 255, 0.2) 50%,
        transparent 70%
      );
      z-index: -1;
      opacity: 0.8;
      filter: blur(4px);
    }
  }

  .badge-name {
    font-size: 11px;
    text-align: center;
    text-shadow:
      0 0 10px rgba(42, 244, 151, 0.8),
      0 0 20px rgba(42, 244, 151, 0.6);
    font-weight: 600;
    letter-spacing: 0.5px;
    color: rgba(255, 255, 255, 0.95);
    transform-style: preserve-3d;
    transform: translateZ(20px);
    padding-top: 2px;
  }
`;

export const CardName = styled.div`
  position: absolute;
  bottom: 90px;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 8px;
  background: rgba(13, 26, 38, 0.8);
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  text-shadow: 0 0 10px rgba(42, 244, 151, 0.9), 0 0 20px rgba(125, 0, 255, 0.5);
  z-index: 3;
  border-top: 1px solid rgba(42, 244, 151, 0.5);
  border-bottom: 1px solid rgba(42, 244, 151, 0.5);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  background: linear-gradient(90deg, rgba(13, 26, 38, 0.9), rgba(21, 42, 36, 0.9), rgba(13, 26, 38, 0.9));
  background-size: 200% 100%;
  animation: ${shine} 5s infinite linear;
  transform-style: preserve-3d;
  transform: translateZ(15px);
  letter-spacing: 1px;

  /* Adicionar uma textura sutil ao fundo */
  background-image:
    linear-gradient(90deg, rgba(13, 26, 38, 0.9), rgba(21, 42, 36, 0.9), rgba(13, 26, 38, 0.9)),
    repeating-linear-gradient(45deg,
      rgba(42, 244, 151, 0.03),
      rgba(42, 244, 151, 0.03) 1px,
      transparent 1px,
      transparent 5px
    );
  background-size: 200% 100%, 6px 6px;
  animation: ${shine} 5s infinite linear;

  /* Efeito de brilho sutil nas bordas */
  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 0;
    width: 100%;
    height: 1px;
  }
`;

// Adicionando CardLevel com display: none
export const CardLevel = styled.div`
  display: none; /* Esconde completamente o elemento */
`;

export const floatIcon = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`;